export default {
  title: 'Stav migrácie {type}',
  resetMessage: 'Naozaj chcete resetovať stav migrácie pre {count} {type}?\nV dôsledku toho budú všetky {type} migrované od najstarších dostupných dát v PT9800.',
};
